import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  FilterLawyerGQL,
  LawyerListComponentGQL,
  LawyerListComponentQuery,
  LawyerListInput,
  SaveListGQL,
} from '../../../generated/graphql';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  providers: [MessageService],
})
export class ListComponent {
  lawyerList = new LawyerListInput();
  alertTypes: LawyerListComponentQuery['alertTypes'] = [];
  judicialDistricts: LawyerListComponentQuery['judicialDistricts'] = [];

  // Task 5.2: add lawyer selection properties
  availableLawyers: Array<{ id: number; fullName: string; name?: string; lastName?: string }> = [];
  selectedLawyers: Array<{ id: number; fullName?: string; name: string; lastName: string }> = [];

  constructor(
    private dialog: MatDialogRef<ListComponent>,
    getService: LawyerListComponentGQL,
    private saveService: SaveListGQL,
    private filterLawyerGQL: FilterLawyerGQL,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.lawyerList.id = data.id;

    getService.fetch({ id: data.id || 0 }).subscribe(s => {
      this.alertTypes = s.data.alertTypes;
      this.judicialDistricts = s.data.judicialDistricts;

      this.lawyerList.alertType = this.alertTypes[0].id;
      this.lawyerList.judicialDistrict = this.judicialDistricts[0].id;

      if (s.data.lawyerList) {
        // Spread only the scalar fields into LawyerListInput (exclude lawyers array of objects)
        const { lawyers: lawyersFromQuery, ...listScalars } = s.data.lawyerList;
        this.lawyerList = { ...listScalars };

        // Task 5.4: preload selectedLawyers from the list's lawyers in edit mode
        if (lawyersFromQuery && lawyersFromQuery.length > 0) {
          this.selectedLawyers = lawyersFromQuery
            .filter(l => l !== null)
            .map(l => ({ id: l!.id, name: l!.name, lastName: l!.lastName, fullName: `${l!.name} ${l!.lastName}` }));
        }
      }
    });

    // Task 5.3: load available lawyers on init
    this.loadAvailableLawyers();
  }

  private loadAvailableLawyers(): void {
    this.filterLawyerGQL.fetch({ pagination: { size: 500, page: 0 } }).subscribe(s => {
      if (s.data.lawyers && s.data.lawyers.content) {
        this.availableLawyers = s.data.lawyers.content.map(l => ({
          id: l.id,
          fullName: l.fullName,
        }));
      }
    });
  }

  // Add lawyer to selectedLawyers if not already there
  onLawyerSelect(lawyerId: number): void {
    if (!lawyerId) return;
    const lawyer = this.availableLawyers.find(l => l.id === lawyerId);
    if (!lawyer) return;
    const alreadySelected = this.selectedLawyers.some(l => l.id === lawyerId);
    if (!alreadySelected) {
      this.selectedLawyers = [
        ...this.selectedLawyers,
        { id: lawyer.id, fullName: lawyer.fullName, name: lawyer.fullName ?? '', lastName: '' },
      ];
    }
  }

  // Remove lawyer from selectedLawyers
  onLawyerRemove(lawyer: { id: number }): void {
    this.selectedLawyers = this.selectedLawyers.filter(l => l.id !== lawyer.id);
  }

  // Task 5.5: include lawyers in save mutation
  save() {
    const lawyerListWithLawyers: LawyerListInput = {
      ...this.lawyerList,
      lawyers: this.selectedLawyers.map(l => l.id),
    };

    this.saveService
      .mutate({ lawyerList: lawyerListWithLawyers })
      .subscribe(_ => this.dialog.close());
  }
}
